<template>
  <div class="filter flex flex-col justify-between">
    <div class="main-filter flex justify-between items-start gap-5 py-3 px-5 overflow-auto no-scrollbar sm:px-0 md:py-4">
      <filter-items
        v-model:filterState="filterState"
        class="flex gap-2 flex-nowrap md:flex-wrap justify-start"
        :base-filter-state="baseFilterState"
        :filter-layout="filterLayout"
        :filter-item-option="filterItemOption"
        :filter-max-count="filterMaxCount"
        :last-submit-filter-state="lastSubmitFilterState"
        :product-count-query-params="props.productCountQueryParams"
        @clear="handleFilterClear"
        @submit="handleSubmit"
        @close="handleFilterClose"
      />
      <div class="sortby items-center ml-auto hidden lg:flex">
        <span class="text-base whitespace-nowrap mr-3">{{ $t('sorting.title') }}</span>
        <filter-item-select v-model="filterState[FilterTypeEnum.SORTBY]" v-bind="filterItemOption[FilterTypeEnum.SORTBY]" class="w-192px" />
      </div>
    </div>
    <div class="sub-filter flex items-center justify-end pl-5 pr-2 py-0.5 lg:hidden sm:px-0 sm:py-3">
      <filter-item-select v-model="filterState[FilterTypeEnum.SORTBY]" mode="icon" v-bind="filterItemOption[FilterTypeEnum.SORTBY]" />
    </div>
  </div>
</template>

<script setup lang="ts">
import FilterItemSelect from '@/components/search/filter/filter-item-select.vue'
import FilterItems from '@/components/search/filter/filter-items.vue'

import type { FilterComponentProps } from '@/types/filters'
import { FilterTypeEnum } from '@/types/filters'
import type { GetProductsReqParams } from '@/types/product'

import { QueryStringKeys } from '@/constants/commons'

interface Props {
  productCountQueryParams: GetProductsReqParams
}

// 外部頁面的狀態
const pageFilterState = defineModel<Partial<FilterComponentProps>>({ required: true })

const props = defineProps<Props>()

const emit = defineEmits({
  update: (value: FilterComponentProps) => value,
  submit: () => true,
  'back-forward': () => true,
})

const route = useRoute()

// filter 相關
const {
  baseFilterState,
  filterItemOption,
  filterLayout,
  filterState,
  lastSubmitFilterState,
  filterMaxCount,
  filterStateUnWrap,
  isNonSubmitButtonChanged,
  handleQueryFilterUpdated,
  reset,
  clear,
  saveLastSubmitted,
} = useSearchFilter()

const queryFilter = computed(() => route.query[QueryStringKeys.SEARCH_FILTER])

// filter item event handlers
const handleFilterClose = (name: string) => reset(name)

const handleFilterClear = (name: string) => clear(name)

const handleUpdate = () => {
  pageFilterState.value = filterStateUnWrap.value
  emit('update', filterStateUnWrap.value)

  if (isNonSubmitButtonChanged.value) handleSubmit()
}

const handleSubmit = async (_name?: string) => {
  await saveLastSubmitted()
  emit('submit')
}

watch(filterState, handleUpdate, { deep: true })

watch(queryFilter, () => {
  const cb = () => {
    pageFilterState.value = filterStateUnWrap.value
    emit('back-forward')
  }

  handleQueryFilterUpdated(cb)
})
</script>

<script lang="ts">
export default {
  name: 'SearchFilter',
}
</script>
